export default function () {
    function resizeBlock() {
        const blocks = document.querySelectorAll(".single-project__left-slider-image");

        blocks.forEach(function (block) {
            const blockWidth = block.width;

            const content = document.querySelector(".single-project__right-slider-slide-content");
            if (content) {
                content.style.height = blockWidth + "px";
            }
        });
    }

    resizeBlock();

    window.addEventListener('resize', resizeBlock);
}
